import React, { useState, useEffect } from 'react';
import { FaFileAlt, FaDownload } from 'react-icons/fa';
import { getApiEndpoint } from '../../../config/api';
import './StaffDashboard.css';

export default function MyDocuments() {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDocuments = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem('token');
        const res = await fetch(getApiEndpoint('/api/staff/documents'), {
          headers: { Authorization: `Bearer ${token}` }
        });
        const data = await res.json();
        setDocuments(data.documents || []);
      } catch (err) {
        setDocuments([]);
      }
      setLoading(false);
    };
    fetchDocuments();
  }, []);

  if (loading) return <div>Loading...</div>;

  return (
    <div className="certificates-grid">
      {documents.map(doc => (
        <div className="certificate-card" key={doc.id}>
          <div className="cert-header">
            <div className="cert-type">
              <FaFileAlt className="cert-icon" />
              <span className="type-label">{doc.type}</span>
            </div>
            <a className="action-btn" href={doc.file_path} download title="Download">
              <FaDownload />
            </a>
          </div>
          <div className="cert-details">
            <h3>{doc.name}</h3>
            <div className="issuer">Uploaded: {doc.uploaded}</div>
          </div>
        </div>
      ))}
    </div>
  );
} 